<script>
import {generateUUID} from "@/utils.js";
import moment from "moment";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import {getRevenueCenters } from "@/api/campaigns.js";
import MarketingRecommendations from "@/view/components/campaign_analytics/MarketingRecommendations.vue";

import {
  getAllapi
} from "@/api/analytics";

export default {
  name: "portlet",
  props: [
    "isNetworkData",
    "formCampaign",

    "disabledInAbsoluteValue",
    "marketing_recommendations",
    "campaignIsSearch"
  ],

  components: {
    VueCtkDateTimePicker,
    MarketingRecommendations
  },
  data() {
    return {
      form: {
        selectedPortlet: 1,
        selectedRevenueList: [],
        selectedYearOver: 1,
      },
      portletOptions:[
        { text: "Customers", value: 1},
        { text: "Average Check", value: 2},
      ],
      overYearOption: [
        { text: "Absolute Value", value: 3},
        { text: "Year over Year", value: 1},
        { text: "Year over 2 Years", value: 2}
      ],
      displayEmptyMessage: false,
      revenueCenterList:[],
      options: {},
      series: [],
      result: [],
      isSearch: true,
      yoyCategoryView: "These values are reported in Year over Year changes",
      maxDisplay: 1,
      hidePortlet: false,
      campaign_start: '',
      campaign_end: '',
      addCampaignStartDate:false,
      addCampaignEndDate:false,
      campaignPeriod: ''
    };
  },
   
  async mounted(){
    let revenueCenterList = await getRevenueCenters()
    this.revenueCenterList = [
      ...revenueCenterList.map(list => {
        return {
          value: list.id,
          text: list.name
        };
      })
    ];
    this.$nextTick(() => {
      this.toggle()// this.form.selectedRevenueList = this.revenueCenterList
      // setTimeout(() => {
      //   this.onSearch()
      // }, 1000);
    });

  },
  computed: {
    chartId() {
      return `chart_${generateUUID()}`;
    },
    likesAllItems() {
      return this.form.selectedRevenueList.length === this.revenueCenterList.length;
    },
    likesSomeItem() {
      return this.form.selectedRevenueList.length > 0 && !this.likesAllItems;
    },
    icon() {
      if (this.likesAllItems) return "mdi-close-box";
      if (this.likesSomeItem) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  }, 
  watch: {
    form: {
      handler(data) {
        this.$emit('watchOverYear', data.selectedYearOver)
      },
      deep: true
    },
    isNetworkData() {
      this.hidePortlet = false
      if(this.isNetworkData){
        this.campaignPeriod = ''
        this.hidePortlet = true
        this.series = [];
        this.setChartOptions();
        this.isSearch= true
      }else{
        this.onSearch()
      }
    },
    // 'formCampaign.selectedYearOver'(){
    //   this.onSearch()
    // }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllItems) {
          this.form.selectedRevenueList = [];
        } else {
          let data = [];
          for (let i = 0; i < this.revenueCenterList.length; i++) {
            let item = this.revenueCenterList[i];
            data.push(item.value);
          }
          this.form.selectedRevenueList = data;
        }
      });
    },

    async onSearch() {
      this.displayEmptyMessage = false;
      try {
        if(this.isNetworkData){
          this.campaignPeriod = ''
          this.hidePortlet = true
          this.series = [];
          this.setChartOptions();
          this.isSearch= true
          return false
        }
        if (!this.formCampaign.selectedCampaign) {
          swal("Notice", "Campaign is required");
          this.isSearch = true
          return false
        }
        if (this.form.selectedRevenueList.length <= 0) {
          swal("Notice", "Please select at least one revenue center");
          this.isSearch = true
          return false
        }
        let campaign_start = moment(this.formCampaign.campaign.date_start).format(
            "MMM-DD-YYYY"
        );
        let campaign_end = moment(this.formCampaign.campaign.date_ended).format(
            "MMM-DD-YYYY"
        );
        
        this.campaign_start = campaign_start.toString();
        this.campaign_end = campaign_end.toString();

        this.isSearch = false
        let start = moment(this.formCampaign.dtpicker.start)
        let end = moment(this.formCampaign.dtpicker.end)

        let daysCount = end.diff(start, 'days')  + 1 // plus 1 coz day 1 is zero value
        let monthCount = end.diff(start, 'months') + 1 // plus 1 coz month 1 is zero value
        let apiDayBasis = 'monthly'

        // 1 ~  14 days= daily
        // 14 days ~ 3 months = weekly
        // else ~ monthly
        if (daysCount <= 14){
          apiDayBasis = 'daily'
        }else if ( (daysCount > 14 && daysCount <= 90) || (monthCount == 3) ){
          apiDayBasis = 'weekly'
        }
        apiDayBasis = 'weekly' 
    
        let yearDataSelected = this.form.selectedYearOver
        let campaignSelected = this.formCampaign.selectedCampaign.value
        let portletSelected = this.form.selectedPortlet
        let revenueSelected = [...this.form.selectedRevenueList]

        const payload = JSON.parse(
          JSON.stringify({
            location_ids: this.formCampaign.selectedItems,
            yearSelect: yearDataSelected,
            portletSelect: portletSelected,
            dayBasis: apiDayBasis,
            campaignId: campaignSelected,
            parameterApi: {
              date: {
                start_date: this.formCampaign.dtpicker.start,
                end_date: this.formCampaign.dtpicker.end
              },
              revenueList: revenueSelected,
            }
          })
        );

        let actualApi = await getAllapi(payload) // existing
        if (!actualApi.resp1 || !actualApi.resp2) {
          this.isSearch = true 
          return false
        }
        if (actualApi.resp1 && actualApi.resp2 && 
        actualApi.resp1.length && actualApi.resp2.length && 
        (actualApi.resp1.length + actualApi.resp2.length) === 0) {
          this.displayEmptyMessage = true
          this.series = [];
          this.setChartOptions();
          this.isSearch = true 
          return false
        }

        let apiresp = actualApi.resp1
        let apiresp2 = actualApi.resp2

        switch (apiDayBasis) {
          case 'weekly':
              for(let i = 0; i < apiresp.length; i++) {
                apiresp[i].date = apiresp[i].week_end
              }
              for(let i = 0; i < apiresp2.length; i++) {
                apiresp2[i].date = apiresp2[i].week_end
              }
            break;
        }
        // for (let i = 0; i < apiresp.length; i++) {
        //     apiresp[i].date = (moment(apiresp[i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
        // }
        // for (let i = 0; i < apiresp2.length; i++) {
        //     apiresp2[i].date = (moment(apiresp2[i].date).add(6, 'days').format("YYYY-MM-DD")).toString()
        // }
        let dates1 = apiresp.map(item => item.date);    
        // Filter dates
        dates1 = dates1.filter((v, i, a) => a.indexOf(v) === i);
        let temp_camp_start =  moment(this.formCampaign.campaign.date_start).format('YYYY-MM-DD').toString()
        let temp_camp_end  =   moment(this.formCampaign.campaign.date_ended).format('YYYY-MM-DD').toString()

        if (!dates1.includes(temp_camp_start)) {
          dates1.push(temp_camp_start.toString());
          dates1 = dates1.sort();
          let start_index = dates1.indexOf(temp_camp_start.toString());
          let value = 0

          if (start_index+1 < dates1.length){
            let dateBefore = dates1[start_index - 1]
            let dateAfter  = dates1[start_index + 1]
            
            let before_value = 0
            let after_value = 0
            let after_values = apiresp.filter(obj => obj.date === dateAfter);            
            after_values.map(item => {after_value=after_value+parseFloat(item.value)})            
            let before_values = apiresp.filter(obj => obj.date === dateBefore)
            before_values.map(item => {before_value=before_value+parseFloat(item.value)})
            value = (Number(before_value) + Number(after_value)) / 2
            
          }
          apiresp.push({
            date : temp_camp_start.toString(),
            value: value
          }) 
        }

        if (!dates1.includes(temp_camp_end)) {
          dates1.push(temp_camp_end.toString());
          dates1 = dates1.sort();

          let end_index = dates1.indexOf(temp_camp_end.toString());
          let value = 0

          if (end_index+1 < dates1.length){
            let dateBefore = dates1[end_index - 1]
            let dateAfter = dates1[end_index + 1]
            let before_value = 0
            let after_value = 0
            let after_values = apiresp.filter(obj => obj.date === dateAfter);            
            after_values.map(item => {after_value=after_value+parseFloat(item.value)})            
            let before_values = apiresp.filter(obj => obj.date === dateBefore)
            before_values.map(item => {before_value=before_value+parseFloat(item.value)})
            value = (Number(before_value) + Number(after_value)) / 2
            
          }
          apiresp.push({
            date : temp_camp_end.toString(),
            value: value
          })     
        }
        dates1 = dates1.sort();

        let dates2 = apiresp2.map(item => item.date);
        dates2 = dates2.filter((v, i, a) => a.indexOf(v) === i);    

        if (!dates2.includes(temp_camp_start)) {
          dates2.push(temp_camp_start.toString());
          dates2 = dates2.sort();
          let start_index = dates2.indexOf(temp_camp_start.toString());
          let value = 0

          if (start_index+1 < dates2.length){
            let dateBefore = dates2[start_index - 1]
            let dateAfter = dates2[start_index + 1]
            let before_value = 0
            let after_value = 0
            let after_values = apiresp2.filter(obj => obj.date === dateAfter);            
            after_values.map(item => {after_value=after_value+parseFloat(item.value)})            
            let before_values = apiresp2.filter(obj => obj.date === dateBefore)
            before_values.map(item => {before_value=before_value+parseFloat(item.value)})
            value = (Number(before_value) + Number(after_value)) / 2            
          }
          apiresp2.push({
            date : temp_camp_start.toString(),
            value: value
          })     
        }

        if (!dates2.includes(temp_camp_end)) {
          dates2.push(temp_camp_end.toString());
          dates2 = dates2.sort();

          let end_index = dates2.indexOf(temp_camp_end.toString());
          let value = 0

          if (end_index+1 < dates2.length){
            let dateBefore = dates2[end_index - 1]
            let dateAfter = dates2[end_index + 1]
            let before_value = 0
            let after_value = 0
            let after_values = apiresp2.filter(obj => obj.date === dateAfter);            
            after_values.map(item => {after_value=after_value+parseFloat(item.value)})            
            let before_values = apiresp2.filter(obj => obj.date === dateBefore)
            before_values.map(item => {before_value=before_value+parseFloat(item.value)})
            value = (Number(before_value) + Number(after_value)) / 2            
          }
          apiresp2.push({
            date : temp_camp_end.toString(),
            value: value
          })
        }
        dates2 = dates2.sort();    

        let existingUser = this.setSeries(apiresp, dates1)
        let newUser = this.setSeries(apiresp2, dates2)
        let  temp_series = []
        let legent1Name = 'Repeat Customers'
        let legen2Name = 'New Customers'
        if(portletSelected == 2){
          legent1Name = 'Repeat Customers Average Check'
          legen2Name = 'New Customers Average Check'
        }

        this.campaignPeriod = `Campaign Started ${this.campaign_start} to ${this.campaign_end}`

        temp_series.push({
          name: legent1Name,        
          data: existingUser
        });

        this.series = temp_series;
        this.setChartOptions();

        temp_series.push({
          name: legen2Name,        
          data: newUser
        });

        this.series = temp_series;
        this.setChartOptions();
        setTimeout(() => {
          this.isSearch = true 
        }, 1000);
      } catch (error) {
        console.log('-- Error in portlet search: ', error)
        this.isSearch = true 
      }
    },
    setSeries(apiData, dateCollection) {
      this.series = [];
      let data = [];
      for (let i = 0; i < dateCollection.length; i++) {
        let d = dateCollection[i];
        let total = 0;
        let filter_results = apiData.filter(
            obj => obj.date == d
        );
        for (let j = 0; j < filter_results.length; j++) {
          let item = filter_results[j];
          total = total + (item.value ? parseFloat(item.value) : 0);
        }
        // data.push(total);

        // total = (filter_results && filter_results.length ? total/filter_results.length : 0);
        total = (filter_results && filter_results.length ? total : 0);
        data.push({
          x: d,
          y: Math.round(total * 100) / 100
        });
      }
      return data

    },
    setChartOptions() {
      // yoy and yo2y = percentages only
      // absolute value + avg customer check = $
      // absolute value + guest = no unit

        //   { text: "Absolute Value", value: 3},
        // { text: "Year over Year", value: 1},
        // { text: "Year over 2 Years", value: 2}

      let yearOver = this.form.selectedYearOver
      let portletSelected = this.form.selectedPortlet
      let yaxisLabel= {
        show: false,
        formatter: function (val) {
          if (val === 0 || val === null) {
            return '0%';
          } else {
            return val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") + '%' ;
          }
        }
      }
      
      if (yearOver == 3) { //absolute value
        yaxisLabel = {
          show: false,
          formatter: function (val) {
             if (portletSelected == 1) { // guest
              if (val === 0 || val === null) {
                return '0';
              } else {
                return Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
             }else{ // average check
              if (val === 0 || val === null) {
                return '$0';
              } else {
                return '$' + val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") 
              }
             }
          }
        }
      }
      this.options = {
        chart: {
          height: 350,
          type: "area",
          toolbar: {
            show: true,
            tools: {
              download:
                  '<i class="flaticon2-download-2" style="color:gray;" title="Download"></i>',
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
              customIcons: []
            }
          }
        },
        colors: [
          "#E91E63",
          "#2E93fA"
        ],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        title: {
          text: `${this.campaignPeriod}`,
          align: "left"
        },
        xaxis: {
          type: "datetime",
          // format chart datetime
          labels: {
            formatter: function (value, timestamp) {
              return moment(value).format('MMM-DD-YYYY')
            }
          }
        },
        yaxis: {
          show: true,
          showAlways: true,
          labels: yaxisLabel
        },
        tooltip: {
          x: {
            format: "MM/dd/yy",
            show: true
          },
          marker: {
            show: true
          }
        },
        annotations: {
          xaxis: [
            {
              x: this.campaign_start,
              x2: this.campaign_end,
              fillColor: "#333333",
              label: {
                style: {
                  color: "#fff",
                  background: "#333333"
                },
                orientation: "horizontal",
                text: "Campaign Range"
              }
            }
          ]
        }
      };
    }
  }
};
</script>

<template>
  <div class="portlet-div">
    <div class="dd-div">
      <div class="mr-2" style="width: 200px; display:inline-block;     vertical-align: top;">
        <v-select 
          v-model="form.selectedYearOver"
          :items="overYearOption"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div>
      <div class="mr-2" style="width: 200px; display:inline-block;     vertical-align: top;">
        <v-select
          v-model="form.selectedPortlet"
          :items="portletOptions"
          required
          dense
          outlined
          background-color="#ffffff"
          height="42"
          :menu-props="{ top: false, offsetY: true }"
        ></v-select>
      </div> 
      <div class="mr-2 " style="width: 200px; display:inline-block;     vertical-align: top;">
        <v-select
          label="Revenue Centers"
            v-model="form.selectedRevenueList"
            :items="revenueCenterList"
            multiple
            required
            dense
            outlined
            background-color="#ffffff"
            height="42"
            :menu-props="{ top: false, offsetY: true }"
          >
          <template v-slot:prepend-item>
            <v-divider class="mt-2"></v-divider>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon
                  :color="form.selectedRevenueList.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Select All
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template
            v-if="form.selectedRevenueList.length > 1"
            v-slot:selection="{ item, index }"
          >
            <span v-if="index === maxDisplay">
              {{ form.selectedRevenueList.length }} selected
            </span>
          </template>
        </v-select>
      </div> 
      <!-- <div class="mr-2" style="width: 80px; display:inline-block;     vertical-align: top;">
        <v-btn
          md
          depressed
          color="primary"
          style="height:40px;"
          @click="onSearch()"
        >
          <v-icon> mdi-magnify</v-icon>
        </v-btn>
      </div> -->
    </div>
    <!-- <div> TEMPORARY HIDE until api is available
      <marketing-recommendations  
        :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
        active_tab="local-market"
        :isNetworkData="isNetworkData"
        :campaignIsSearch="campaignIsSearch"
        :disabledInAbsoluteValue="disabledInAbsoluteValue"
        :form="formCampaign"  
        :marketing_recommendations="marketing_recommendations" 
      ></marketing-recommendations>
    </div> -->
    <v-card class="no-shadow">
      <div class="content-box">
        <v-card class=" v-card-portlet">
          <v-row class="justify-space-between zindex-99" >
            <div class="mt-3 ml-3">
              <v-alert outlined type="info" text class="outer-container ml-2" width="500">
                <span v-if="this.form.selectedYearOver === 1">These values are reported in year over year changes</span>
                <span v-if="this.form.selectedYearOver === 2">These values are reported in year over 2 year changes</span>
                <span v-if="this.form.selectedYearOver === 3">These values are reported in absolute value changes</span>
              </v-alert>
            </div>
          </v-row>
          <v-container fluid>
            <v-container fluid v-if="!isSearch">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-container>
            <!-- type="area" -->
            <div v-if="hidePortlet">
                 These metrics are unavailable when using Network Data Only
            </div>
            <div v-if="displayEmptyMessage">
              <v-alert outlined type="info" text class="outer-container ml-2" width="500">
                <span>No data found for the selected Revenue Center.</span>
              </v-alert>
            </div>
            <apexchart
                :options="options"
                :series="series"
                height="300"
                type="area"
                :id="chartId"
            ></apexchart>
          </v-container>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<style>
  .ac-dropdown-container > div{
    margin-left: 10px;
    display: inline-block;
    max-width: 200px;
  }
  .ac-dropdown-container {
    float: right;
    margin-right: 0px;
  }
  .zindex-99{
    position: relative;
    z-index: 10;
  }
  .v-item--active .new-vs-repeat-accord .dd-div{
    top: 10px;
    position: absolute;
    right: 70px;
  }
  .v-card-portlet.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none !important;
  }
  .no-shadow{
    box-shadow: none !important;
    border: none;
  }

  .sb-p{
    color: #666666;
    font-size: 14px;
  }
  @media screen and (max-width: 1025px) {
    .v-item--active .new-vs-repeat-accord .dd-div{
      position: relative;
      right: 0;
      top: 0;
      padding-left: 10px;
    }
  }
</style>